'use strict';
import isString from 'lodash/isString';
import {blockPromise} from '../../core-utilities/misc-utils/MiscUtils';
import {showManageAccess} from './redux';


ManageAccessDirective.$inject = [
  '$parse',
  '$ngRedux',
];

export function ManageAccessDirective(
  $parse,
  $ngRedux,
) {
  const errorMsg = 'ManageAccessDirective Requires an expression that returns an access managed targetDomain';

  return {
    restrict: 'E',
    template: '<i class="icon ion-person-stalker title="{{\'icon.manageAccess.title\' | translate}}">',
    compile: function ($element, attr) {
      if (!isString(attr.targetDomain)) throw new Error(errorMsg);

      // Mirroring ngClick implementation
      const getTargetDomain = $parse(attr.targetDomain, /* interceptorFn */ null, /* expensiveChecks */ true);
      return function bindOnClick(scope, element) {
        element.on('click', event => {
          const callback = () => {
            const target = getTargetDomain(scope);
            return target
              ? $ngRedux.dispatch(showManageAccess({target}))
              : Promise.reject(new Error(errorMsg));
          };
          scope.$safeApply(blockPromise(callback));
        });
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/core-components/manage-access/ManageAccessDirective.js